function dm_team_filter () {
    const teamFilterForm = document.querySelector('#team-filter-form');
    const levelFilters = document.querySelectorAll('.filter-level');

    function applyFilter () {
        const services = Array.from(teamFilterForm.querySelectorAll('input[name="service"]'))
            .filter(serviceInput => serviceInput.checked).map(serviceInput => +serviceInput.value);

        const offices = Array.from(teamFilterForm.querySelectorAll('input[name="office"]'))
            .filter(officeInput => officeInput.checked).map(officeInput => officeInput.value);

        const levels = [];
        for (const levelFilter of levelFilters) {
            if (levelFilter.classList.contains('active')) {
                levels.push(levelFilter.dataset.level);
            }
        }

        const searchKeyword = teamFilterForm.querySelector('input[name="search"]').value;

        const cards = document.querySelectorAll('.profiles .card');
        let hasResults = false;
        for (const card of cards) {
            let isShown = true;
            if (services.length) {
                const dataServices = card.dataset.services;
                const cardServices = JSON.parse(dataServices).map(dataService => +dataService);
                isShown = cardServices.some(cs => services.includes(cs));
            }

            if (isShown && offices.length) {
                const dataOffices = card.dataset.offices;
                const cardOffices = JSON.parse(dataOffices).map(dataOffice => dataOffice);

                isShown = cardOffices.some(cs => offices.includes(cs));
            }

            if (isShown && searchKeyword) {
                const lookupWords = [
                    card.dataset.name,
                    card.dataset.position,
                ].filter(word => !!word);
                isShown = false;
                for (const lookupWord of lookupWords) {
                    if (lookupWord.toLowerCase().includes(searchKeyword.trim().toLowerCase())) {
                        isShown = true;
                        break;
                    }
                }
            }

            if (isShown && levels.length) {
                const level = card.dataset.level;
                isShown = levels.includes(level);
            }

            if (isShown) {
                card.classList.remove('card-hidden');
            } else {
                card.classList.add('card-hidden');
            }

            if (!hasResults && isShown) hasResults = true;
        }

        const noResultsEls = document.querySelectorAll('.profiles .no-results');
        if (hasResults) {
            for (const noResultsEl of noResultsEls) {
                noResultsEl.classList.add('d-none');
            }
        } else {
            for (const noResultsEl of noResultsEls) {
                noResultsEl.classList.remove('d-none');
            }
        }
    }

    function closeFilterPanel () {
        for (const filterItem of teamFilterForm.querySelectorAll('.filter-item')) {
            filterItem.classList.remove('open');
        }
    }

    teamFilterForm?.addEventListener('submit', (e) => {
        e.preventDefault();
        teamFilterForm.querySelector('input[name="search"]').value = '';
        applyFilter();
        closeFilterPanel();
    });

    teamFilterForm?.querySelector('.search-form button').addEventListener('click', (e) => {
        e.preventDefault();
        applyFilter();
    });

    teamFilterForm?.querySelector('input[name="search"]').addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            applyFilter();
        }
    });

    teamFilterForm?.querySelector('input[name="search"]').addEventListener('input', (e) => {
        applyFilter();
    });

    for (const levelFilter of levelFilters) {
        levelFilter.addEventListener('click', (e) => {
            e.preventDefault();
            if (levelFilter.classList.contains('active')) {
                levelFilter.classList.remove('active');
            } else {
                levelFilter.classList.add('active');
            }

            applyFilter();
        });
    }
}


function dm_c_16_profiles_grid_search(){
    dm_team_filter();

    const sections = document.querySelectorAll('section.c-16-profiles-grid-search');
    if (!sections.length) return;

    sections.forEach((section) => {
        const filters = section.querySelectorAll('.filter-item a');
        filters.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const item = link.closest('.filter-item') || link;

                section.querySelectorAll('.filter-item.open').forEach((openEl) => {
                    if (openEl !== item) openEl.classList.remove('open');
                });

                item.classList.toggle('open');
            });
        });
    });
}

export { dm_c_16_profiles_grid_search };
